import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Cookie } from 'ng2-cookies/ng2-cookies';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.css']
})
export class LogoutComponent implements OnInit {

  cookies: Object;
  constructor(
       // private route: ActivatedRoute,
        private router: Router
      ) {
        this.cookies = Cookie.getAll();
        Cookie.delete('TokenKey');
        this.router.navigate(['']);
       }
  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/wamp64/www/duetz.repos/angular4/src/app/_components/logout/logout.component.ts